import script from "./bookings.vue?vue&type=script&setup=true&lang=js"
export * from "./bookings.vue?vue&type=script&setup=true&lang=js"

import "./bookings.vue?vue&type=style&index=0&id=70bda7fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70bda7fc"]])

export default __exports__